
import { defineComponent, computed } from 'vue';
import { resolveManagerImage } from '../utils/site-config';

// Manager-driven promotion pop-up: a single image (optionally linking to href)
// shown on the homepage when the operator enables it in the manager
// (managerConfig.promotionPopup.show). Purely presentational — the props carry
// the resolved config so the component has no store dependency. Closing is
// handled by the showVuePopup (SweetAlert2) wrapper's own close button, so the
// component renders only the image.
export default defineComponent({
	name: 'PromotionPopup',
	props: {
		image: { type: String, default: '' },
		href: { type: String, default: '' },
		alt: { type: String, default: '' },
		close: { type: Function, default: undefined },
	},
	setup(props) {
		// Relative manager image paths must be resolved against the manager
		// origin, not the WP site origin (see resolveManagerImage).
		const src = computed(() => resolveManagerImage(props.image));
		return { src };
	},
});
